export default __webpack_public_path__ + "static/media/facebook.9644c89f.png";